import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DiffusionService } from 'src/services/diffusion.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { VimeoInfoModel } from 'src/models/pilotage/vimeoInfoModel';
import Player from '@vimeo/player';

@Component({
    selector: 'app-vimeo-player',
    templateUrl: './vimeo-player.component.html',
    styleUrls: ['./vimeo-player.component.css'],
    imports: [MatIconModule, MatProgressSpinnerModule]
})
export class VimeoPlayerComponent implements OnInit, OnDestroy {
  vimeoInfo: VimeoInfoModel | null = null;
  vimeoUrl: SafeResourceUrl | null = null;
  loading: boolean = true;
  error: string | null = null;
  token: string | null = null;

  @ViewChild('vimeoIframe') vimeoIframe!: ElementRef<HTMLIFrameElement>;

  private player: Player | null = null;
  private indexCourant: number = 0;

  constructor(
    private route: ActivatedRoute,
    private diffusionService: DiffusionService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];

      if (!this.token) {
        this.error = 'Aucun token fourni.';
        this.loading = false;
        return;
      }

      this.loadVimeoPlayer();
    });
  }

  ngOnDestroy(): void {
    this.player?.destroy();
  }

  loadVimeoPlayer(): void {
    this.loading = true;
    this.error = null;

    this.diffusionService.obtenirVimeoIdParToken(this.token!).subscribe({
      next: (vimeoInfo) => {
        this.vimeoInfo = vimeoInfo;
        this.indexCourant = 0;
        const estVideoUnique = vimeoInfo.vimeoIds.length === 1;
        this.vimeoUrl = this.construireUrl(vimeoInfo.vimeoIds[0], estVideoUnique);
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        if (err.status === 404) {
          this.error = 'Token invalide ou diffusion expirée.';
        } else if (err.status === 400) {
          this.error = 'Token manquant ou invalide.';
        } else {
          this.error = 'Une erreur est survenue lors du chargement de la vidéo.';
        }
        console.error('Erreur lors du chargement du VimeoId:', err);
      }
    });
  }

  onIframeLoad(): void {
    if (!this.vimeoInfo || this.vimeoInfo.vimeoIds.length <= 1 || this.player) return;

    this.player = new Player(this.vimeoIframe.nativeElement);
    this.player.on('ended', () => this.passerVideoSuivante());
  }

  private construireUrl(vimeoId: string, loop: boolean): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://player.vimeo.com/video/${vimeoId}?autoplay=1&muted=1&loop=${loop ? 1 : 0}&autopause=0&controls=0&title=0&byline=0&portrait=0&texttrack=${this.vimeoInfo!.langue}`
    );
  }

  private passerVideoSuivante(): void {
    this.indexCourant = (this.indexCourant + 1) % this.vimeoInfo!.vimeoIds.length;
    this.player!.loadVideo(parseInt(this.vimeoInfo!.vimeoIds[this.indexCourant]))
      .then(() => this.player!.play());
  }
}
